module.exports = __webpack_public_path__ + "img/paynow_qr.0a0b70f9.png";